import { utils } from '@resy/ui-kitchen';
import { getVenue } from '../../../../ui-kitchen/src/api/api';
import { venueTransform } from '../../../../ui-kitchen/src/api/resyApiTransformer';

const { getLocationSlug } = utils;

/* eslint-disable no-param-reassign */

angular
  .module('resyApp')
  .controller('LinkCtrl', LinkCtrl);

function LinkCtrl($location, $scope, $timeout, $window) {
  const ua = $window.navigator.userAgent;
  const params = $location.search();
  const queryParamNames = [
    'venue_id',
    'table_config_id',
    'time_slot',
    'timeslot',
    'day',
    'date',
    'num_seats',
    'seats',
    'location_id',
    'request_start',
    'request_end',
    'notify_request_id', // to be deprecated
    'request_id',
  ];

  const isIos = (ua.indexOf('iPhone') >= 0 || ua.indexOf('iPad') >= 0);
  let deeplinkUrl;
  let linkQueryParams;

  function getQueryParams() {
    const paramArray = [];

    for (let i = 0; i < queryParamNames.length; i += 1) {
      if (typeof params[queryParamNames[i]] !== 'undefined') {
        paramArray.push(`${queryParamNames[i]}=${encodeURIComponent(params[queryParamNames[i]])}`);
      }
    }
    return paramArray.join('&');
  }

  function redirect() {
    const redirectParams = linkQueryParams.replace('day', 'date');

    if (typeof params.location !== 'undefined') {
      if (params.location.indexOf('?') >= 0) {
        $window.location = `${params.location}&${redirectParams}`;
      } else {
        $window.location = `${params.location}?${redirectParams}`;
      }
    } else if (params.venue_id !== 'undefined') {
      params.venue_id = parseInt(params.venue_id, 10).toString();

      getVenue({ id: params.venue_id })
        .then((response) => {
          const data = venueTransform(response);
          const locationSlug = getLocationSlug(data.location);
          let redirectPath = `/cities/${locationSlug}/venues/${data.urlSlug}`;
          const venuePageParams = {};

          if ('date' in params || 'day' in params) {
            venuePageParams.date = params.date || params.day;
          }

          if ('seats' in params || 'num_seats' in params) {
            venuePageParams.seats = params.seats || params.num_seats;
          }

          if ('table_config_id' in params) {
            venuePageParams.table_config_id = params.table_config_id;
          }

          if ('timeslot' in params || 'time_slot' in params) {
            venuePageParams.timeslot = params.timeslot || params.time_slot;
          }

          if ('notify_request_id' in params) {
            venuePageParams.notify_request_id = params.notify_request_id;
          } else if ('request_id' in params) {
            venuePageParams.notify_request_id = params.request_id;
          }

          if ('request_start' in params) {
            venuePageParams.request_start = params.request_start;
          }

          if ('request_end' in params) {
            venuePageParams.request_end = params.request_end;
          }

          if ('event_url_slug' in params) {
            redirectPath = `/cities/${locationSlug}/venues/${data.urlSlug}/events/${params.event_url_slug}`;
            venuePageParams.event_url_slug = params.event_url_slug;
            venuePageParams.maxPartySize = 50; // This should either come from the event or the params
          }

          const keys = Object.keys(params);
          keys.forEach((key) => {
            if (key.substr(0, 4) === 'utm_') {
              venuePageParams[key] = params[key];
            }
          });

          $location.search(venuePageParams);
          $location.url(redirectPath);
          $location.search(venuePageParams);
        })
        .catch(() => $location.url('/')); // venue not found
    } else {
      $location.url('/');
    }
  }

  linkQueryParams = getQueryParams();

  if (isIos === true) {
    deeplinkUrl = 'fb375094832642014://resy.com/';

    if (typeof params.venue_id === 'undefined') {
      deeplinkUrl += 'FinderResults';
    } else if (typeof params.time_slot === 'undefined') {
      deeplinkUrl += 'VenueDetails';
    } else {
      deeplinkUrl += 'ReservationDetails';
    }

    deeplinkUrl += `?${linkQueryParams}`;
    angular.element($window.document.body).append(`<iframe src="${deeplinkUrl}"></iframe>`);

    $timeout(redirect, 250);
  } else {
    redirect();
  }
}

export default () => {};
